import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyCOgKkqU6EdsYI8UZ5627hXYciL1znNDB8",
  authDomain: "eitx-website.firebaseapp.com",
  databaseURL: "https://eitx-website.firebaseio.com",
  projectId: "eitx-website",
  storageBucket: "eitx-website.appspot.com",
  messagingSenderId: "1065337982720"
};
const fire = firebase.initializeApp(config); //eslint-disable-line

export default firebase;



// WEBPACK FOOTER //
// ./src/firebase/firebase.js